export default function Restaurant() {
  return (
    <div className="min-h-screen bg-cream-100">

      {/* Hero */}
      <div className="relative h-64 lg:h-80 overflow-hidden">
        <img src="/images/optimized/IMG_5147.webp" fetchPriority="high"
          className="h-full w-full object-cover" alt="The Kitchen at Scenic Solitude" />
        <div className="absolute inset-0 bg-forest-950/55" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/55 font-semibold mb-3">Dining</p>
          <h1 className="text-4xl font-semibold text-white tracking-tight">The Kitchen</h1>
          <p className="mt-2 text-sm text-white/60">Fresh valley meals · Himachali cooking · Wood fire</p>
        </div>
      </div>

      {/* Body */}
      <div className="mx-auto max-w-2xl px-8 lg:px-16 py-24 text-center">

        <span className="text-[10px] tracking-[0.35em] uppercase text-ink-muted font-semibold mb-6 block">
          A Note for Our Visitors
        </span>

        <p className="text-ink-soft font-light leading-[1.9] text-base mb-6">
          At the moment, our dining space and fresh valley meals are reserved only for guests staying in our rooms and treehouses.
        </p>

        <p className="text-ink-soft font-light leading-[1.9] text-base mb-6">
          We are slowly preparing our kitchen to welcome outside visitors in the near future. Thank you for your patience while we build this space.
        </p>

        {/* Forest green highlight box */}
        <div className="mt-10 px-8 py-8 text-left" style={{ backgroundColor: '#1e3525' }}>
          <p className="text-[9px] tracking-[0.35em] uppercase text-white/45 font-semibold mb-3">For In-House Guests</p>
          <p className="text-white/80 font-light leading-[1.9] text-sm">
            If you are an in-house guest, your daily meals are fully taken care of and cooked fresh every day.
          </p>
        </div>

        <div className="mt-12">
          <a href="/inquire" className="btn-outline-aman text-ink">Reserve a Room</a>
        </div>

      </div>

    </div>
  )
}
